import React from 'react';
import Error404 from 'ui-component/icons/404';

const CMP = () => {
  return (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        textAlign: 'center',
        transform: 'translate(-50%, -50%)'
      }}
    >
      <div>
        <Error404 width={244} height={208} />
      </div>
      <div>
        您访问的页面不存在，返回{' '}
        <a href="/dashboard" style={{ cursor: 'pointer', textDecoration: 'undeline' }}>
          首页
        </a>
      </div>
    </div>
  );
};

export default CMP;
